import React from 'react';

export const PlayIcon: React.FC<{
  width?: number;
  height?: number;
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  classes?: string;
}> = ({
  width = 22,
  height = 20,
  fillColor = 'none',
  strokeWidth = 1,
  classes = '',
  strokeColor = 'text-black',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    strokeWidth={strokeWidth}
    viewBox="0 0 22 20"
    fill={fillColor}
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    Continuing from where we left off:
    <path
      d="M5 3L17 10L5 17V3Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
